import { useEffect, useState } from 'react';

/**
 * Tracks the OS "reduce motion" accessibility setting. Games use it to shorten
 * or skip long spin/drop animations (and the CSS guard in globals.css collapses
 * keyframes under `[data-game-motion]`).
 */
export function usePrefersReducedMotion(): boolean {
  const [reduced, setReduced] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    setReduced(mq.matches);
    const onChange = (e: MediaQueryListEvent) => setReduced(e.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return reduced;
}
